module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_7-905243a8.jpg";